module.exports = __webpack_public_path__ + "img/2.9.TU.a1efa190.png";